import { gql } from '@apollo/client'
import { PERMISSIONS_FRAGMENT } from 'graphql/securityProfiles/queries'

export const OBJECT_SECURITIES_QUERY = gql`
  query OBJECT_SECURITIES_QUERY($filter: ObjectSecurityFilter, $order: OrderInput, $pagination: PaginationInput) {
    objectSecurities(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        companyId
        createdAt
        updatedAt
        name
        description
        active
        securityProfiles {
          id
          active
          name
          permissions {
            ...PERMISSIONS
          }
        }
        objectEntityId
        objectEntity {
          id
          apiName
          name
        }
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
  ${PERMISSIONS_FRAGMENT}
`
